import {ElementKeys} from '../ElementKeys'
export default {
  methods: {
    removeFromArray(module, value, array, device = null, elementOverride = new Object, touchDevice = true, parentModule = null) {
      this.$store.dispatch(`${module}/removeFromArray`, {
        element: (new ElementKeys(module, {...this.element, ...elementOverride})).keys(),
        array: array,
        value: value,
        device: device,
        touchDevice: touchDevice,
        parentModule: parentModule,
      })
    },
    addToArray(module, value, array, device = null, elementOverride = new Object, touchDevice = true, parentModule = null) {
      this.$store.dispatch(`${module}/addToArray`, {
        element: (new ElementKeys(module, {...this.element, ...elementOverride})).keys(),
        array: array,
        value: value,
        device: device,
        touchDevice: touchDevice,
        parentModule: parentModule
      })
    },
    addToObject(module, value, object, device = null, elementOverride = new Object, touchDevice = true, parentModule = null) {
      this.$store.dispatch(`${module}/addToObject`, {
        element: (new ElementKeys(module, {...this.element, ...elementOverride})).keys(),
        object: object,
        value: value,
        device: device,
        touchDevice: touchDevice,
        parentModule: parentModule
      })
    }
  }
}